// import React from "react";
// import "@fortawesome/fontawesome-free/css/all.min.css";

// /* ===== Fleet Images ===== */
// const galleryData = [
//   {
//     id: 1,
//     imgSrc: "/images/fleet/Swift-Dzire.png",
//     title: "Swift Dzire",
//   },
//   {
//     id: 2,
//     imgSrc: "/images/fleet/Maruti-Ertiga.png",
//     title: "Maruti Ertiga",
//   },
//   {
//     id: 3,
//     imgSrc: "/images/fleet/Toyota-Rumion.png",
//     title: "Toyota Rumion",
//   },
//   {
//     id: 4,
//     imgSrc: "/images/fleet/Kia-Carens.png",
//     title: "Kia Carens",
//   },
//   {
//     id: 5,
//     imgSrc: "/images/fleet/Innova-Cab.png",
//     title: "Innova Cab",
//   },
//   {
//     id: 6,
//     imgSrc: "/images/fleet/Innova-Crysta.png",
//     title: "Innova Crysta",
//   },
//   {
//     id: 7,
//     imgSrc: "/images/fleet/Tempo-Traveller.png",
//     title: "Tempo Traveller",
//   },
//   {
//     id: 8,
//     imgSrc: "/images/fleet/Urbania-Bus.png",
//     title: "Urbania Bus",
//   },
//   {
//     id: 9,
//     imgSrc: "/images/fleet/Mini-Bus.png",
//     title: "Mini Bus",
//   },
// ];

// /* ===== Fleet Cards ===== */
// const fleetCards = [
//   {
//     title: "Swift Dzire",
//     company: "Mumbai Airport Cabs",
//     seater: "4+1",
//     desc: "Popular sedan perfect for airport transfers, local travel and outstation trips.",
//   },
//   {
//     title: "Maruti Ertiga",
//     company: "Mumbai Airport Cabs",
//     seater: "6+1",
//     desc: "Spacious MPV ideal for family trips and small group travel.",
//   },
//   {
//     title: "Toyota Rumion",
//     company: "Mumbai Airport Cabs",
//     seater: "6+1",
//     desc: "Comfortable MPV suitable for airport transfers and outstation journeys.",
//   },
//   {
//     title: "Kia Carens",
//     company: "Mumbai Airport Cabs",
//     seater: "6+1",
//     desc: "Premium MPV with modern features and comfortable seating.",
//   },
//   {
//     title: "Innova Cab",
//     company: "Mumbai Airport Cabs",
//     seater: "7+1",
//     desc: "Reliable MPV ideal for family trips, airport transfers and business travel.",
//   },
//   {
//     title: "Innova Crysta",
//     company: "Mumbai Airport Cabs",
//     seater: "7+1",
//     desc: "Luxury MPV offering premium comfort for corporate and family travel.",
//   },
//   {
//     title: "Tempo Traveller",
//     company: "Mumbai Airport Cabs",
//     seater: "13-17",
//     desc: "Best choice for group tours, corporate outings and family functions.",
//   },
//   {
//     title: "Urbania Bus",
//     company: "Mumbai Airport Cabs",
//     seater: "17",
//     desc: "Premium luxury traveller with spacious seating and superior comfort.",
//   },
//   {
//     title: "Mini Bus",
//     company: "Mumbai Airport Cabs",
//     seater: "20-32",
//     desc: "Ideal for corporate events, weddings and large group transportation.",
//   },
// ];

// export default function Booking({ cards = fleetCards }) {
//   const getGalleryItem = (title) =>
//     galleryData.find(
//       (item) => item.title.toLowerCase() === title.toLowerCase()
//     );

//   const handleWhatsAppBooking = (title) => {
//     const phone = "919545731161";

//     const message = `Hello Mumbai Airport Cabs, I want to book ${title}. Please share more details.`;

//     window.open(
//       `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
//       "_blank"
//     );
//   };

//   return (
//     <>
//       {/* ===== Breadcrumb ===== */}


//      <div
//         className="breadcumb-wrapper"
//         style={{
//           backgroundImage: "url('/images/breadcumb/breadcumb-bg.png')",
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div className="container z-index-common">
//           <div className="breadcumb-content">
//             <h1 className="breadcumb-title">Online Booking</h1>
//           </div>
//         </div>
//       </div>
 

//       {/* ===== Fleet Section ===== */}
//       <section
//         className="taxi-rates-page section-space"
//         style={{
//           backgroundColor: "#f9fafc",
//           padding: "80px 0",
//         }}
//       >
//         <div className="container">
//           <div className="row g-4 justify-content-center">
//             {cards.map((c, idx) => {
//               const galleryItem = getGalleryItem(c.title);

//               return (
//                 <div className="col-xl-4 col-md-6 d-flex" key={idx}>
//                   <div
//                     className="taxi-card d-flex flex-column w-100"
//                     style={{
//                       borderRadius: "15px",
//                       overflow: "hidden",
//                       boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
//                     }}
//                   >
//                     {/* Vehicle Image */}
//                     <div
//                       style={{
//                         background: "#4EA5DA",
//                         padding: "20px",
//                         textAlign: "center",
//                       }}
//                     >
//                       <img
//                         src={galleryItem?.imgSrc}
//                         alt={c.title}
//                         style={{
//                           width: "100%",
//                           height: "220px",
//                           objectFit: "contain",
//                         }}
//                       />
//                     </div>

//                     {/* Content */}
//                     <div
//                       className="d-flex flex-column justify-content-between"
//                       style={{
//                         background: "#1A4160",
//                         color: "#fff",
//                         padding: "25px",
//                         flex: 1,
//                       }}
//                     >
//                       <div>
//                         <h3
//                           style={{
//                             textAlign: "center",
//                             color: "#fff",
//                             marginBottom: "15px",
//                           }}
//                         >
//                           {c.title}
//                         </h3>

//                         <p
//                         className="text-white"
//                           style={{
//                             textAlign: "center",
//                             marginBottom: "10px",
//                             lineHeight: "1.6",
//                           }}
//                         >
//                           {c.desc}
//                         </p>

//                         <p
//                          className="text-white"
//                           style={{
//                             textAlign: "center",
//                             fontWeight: "700",
//                             fontSize: "18px",
//                           }}
//                         >
//                           <i className="fas fa-users me-2"></i>
//                           Seater: {c.seater}
//                         </p>
//                       </div>

//                       <button
//                         onClick={() => handleWhatsAppBooking(c.title)}
//                         className="btn btn-success mt-3"
//                         style={{
//                           borderRadius: "50px",
//                           padding: "12px",
//                           fontWeight: "600",
//                         }}
//                       >
//                         <i className="fab fa-whatsapp me-2"></i>
//                         Book Now
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }




import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

/* ===========================
        Fleet Images
=========================== */

const galleryData = [
  {
    id: 1,
    imgSrc: "/images/fleet/Swift-Dzire.png",
    title: "Swift Dzire",
  },
  {
    id: 2,
    imgSrc: "/images/fleet/Maruti-Ertiga.png",
    title: "Maruti Ertiga",
  },
  {
    id: 3,
    imgSrc: "/images/fleet/Toyota-Rumion.png",
    title: "Toyota Rumion",
  },
  {
    id: 4,
    imgSrc: "/images/fleet/Kia-Carens.png",
    title: "Kia Carens",
  },
  {
    id: 5,
    imgSrc: "/images/fleet/Innova-Cab.png",
    title: "Innova Cab",
  },
  {
    id: 6,
    imgSrc: "/images/fleet/Innova-Crysta.png",
    title: "Innova Crysta",
  },
  {
    id: 7,
    imgSrc: "/images/fleet/Tempo-Traveller.png",
    title: "Tempo Traveller",
  },
  {
    id: 8,
    imgSrc: "/images/fleet/Urbania-Bus.png",
    title: "Urbania Bus",
  },
  {
    id: 9,
    imgSrc: "/images/fleet/Mini-Bus.png",
    title: "Mini Bus",
  },
];

/* ===========================
        Fleet Cards
=========================== */

const fleetCards = [
  {
    title: "Swift Dzire",
    company: "Mumbai Airport Cabs",
    seater: "4+1",
    desc: "Comfortable sedan for airport transfers, local rides and outstation trips.",
  },
  {
    title: "Maruti Ertiga",
    company: "Mumbai Airport Cabs",
    seater: "6+1",
    desc: "Spacious MPV for families, airport pickup and long distance travel.",
  },
  {
    title: "Toyota Rumion",
    company: "Mumbai Airport Cabs",
    seater: "6+1",
    desc: "Premium family car with spacious seating and luggage space.",
  },
  {
    title: "Kia Carens",
    company: "Mumbai Airport Cabs",
    seater: "6+1",
    desc: "Luxury MPV with stylish interiors for comfortable travel.",
  },
  {
    title: "Innova Cab",
    company: "Mumbai Airport Cabs",
    seater: "7+1",
    desc: "Reliable Toyota vehicle for airport and outstation journeys.",
  },
  {
    title: "Innova Crysta",
    company: "Mumbai Airport Cabs",
    seater: "7+1",
    desc: "Luxury cab with premium comfort for business and family travel.",
  },
  {
    title: "Tempo Traveller",
    company: "Mumbai Airport Cabs",
    seater: "13-17",
    desc: "Best for group tours, pilgrimages and corporate outings.",
  },
  {
    title: "Urbania Bus",
    company: "Mumbai Airport Cabs",
    seater: "17",
    desc: "Premium luxury traveller with spacious seats and modern comfort.",
  },
  {
    title: "Mini Bus",
    company: "Mumbai Airport Cabs",
    seater: "20-32",
    desc: "Ideal for weddings, corporate events and group transportation.",
  },
];

export default function Booking({ cards = fleetCards }) {
  const getGalleryItem = (title) =>
    galleryData.find(
      (item) => item.title.toLowerCase() === title.toLowerCase()
    );

  const handleWhatsAppBooking = (title) => {
    const phone = "919545731161";

    const message = `Hello Mumbai Airport Cabs, I want to book ${title}. Please share more details.`;

    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <>
      {/* Breadcrumb */}

      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Online Booking</h1>
          </div>
        </div>
      </div>

      

      {/* Fleet Section */}

      <section
        style={{
          background: "#D4A64A",
          padding: "70px 0",
        }}
      >
        <div className="container">
          <div className="row g-4">{cards.map((c, idx) => {
  const galleryItem = getGalleryItem(c.title);

  return (
    <div className="col-12" key={idx}>
      <div
        style={{
          background: "#fff",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 12px 35px rgba(0,0,0,.12)",
          transition: ".35s",
          border: "1px solid #e6ecf2",
        }}
      >
        <div className="row g-0 align-items-center">

          {/* Vehicle Image */}

          <div className="col-lg-4 col-md-5">
            <div
              style={{
                // background: "linear-gradient(135deg,#12385C,#235A8A)",
                // padding: "25px",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={galleryItem?.imgSrc}
                alt={c.title}
                style={{
                  width: "100%",
                  maxWidth: "320px",
                  height: "220px",
                  objectFit: "contain",
                  border:"3px solid #12385C",
                }}
              />
            </div>
          </div>

          {/* Details */}

          <div className="col-lg-8 col-md-7">

            <div className="p-4 p-lg-5">

              <span
                style={{
                  background: "#D4A64A",
                  color: "#12385C",
                  padding: "6px 15px",
                  borderRadius: "30px",
                  fontWeight: "700",
                  fontSize: "14px",
                }}
              >
                Mumbai Airport Cabs
              </span>

              <h2
                style={{
                  marginTop: "18px",
                  color: "#12385C",
                  fontWeight: "700",
                }}
              >
                {c.title}
              </h2>

              {/* <p
                style={{
                  color: "#666",
                  lineHeight: "1.8",
                  marginTop: "15px",
                  marginBottom: "25px",
                }}
              >
                {c.desc}
              </p> */}

              <div className="row gy-3">

                <div className="col-lg-6">
                  <div
                    style={{
                      background: "#12385C",
                      borderRadius: "12px",
                      padding: "12px 15px",
                      color: "white",
                    }}
                  >
                    <i
                      className="fas fa-users"
                      style={{
                        color: "#D4A64A",
                        marginRight: "10px",
                      }}
                    ></i>

                    <strong>Seating :</strong> {c.seater}
                  </div>
                </div>

                <div className="col-lg-6">
                  <div
                    style={{
                      background: "#12385C",
                      borderRadius: "12px",
                      padding: "12px 15px",
                      color: "white",
                    }}
                  >
                    <i
                      className="fas fa-snowflake"
                      style={{
                        color: "#D4A64A",
                        marginRight: "10px",
                      }}
                    ></i>

                    Fully Air Conditioned
                  </div>
                </div>

                <div className="col-lg-6">
                  <div
                    style={{
                      background: "#12385C",
                      borderRadius: "12px",
                      padding: "12px 15px",
                      color: "white",
                    }}
                  >
                    <i
                      className="fas fa-user-tie"
                      style={{
                        color: "#D4A64A",
                        marginRight: "10px",
                      }}
                    ></i>

                    Professional Driver
                  </div>
                </div>

                <div className="col-lg-6">
                  <div
                    style={{
                      background: "#12385C",
                      borderRadius: "12px",
                      padding: "12px 15px",
                      color: "white",
                    }}
                  >
                    <i
                      className="fas fa-route"
                      style={{
                        color: "#D4A64A",
                        marginRight: "10px",
                        
                      }}
                    ></i>

                    Airport & Outstation
                  </div>
                </div>

              </div>

              <div
                className="d-flex flex-wrap align-items-center justify-content-between mt-4"
              >

             

                <button
                  onClick={() => handleWhatsAppBooking(c.title)}
                  style={{
                    background: "#12385C",
                    color: "#fff",
                    border: "none",
                    padding: "14px 34px",
                    borderRadius: "40px",
                    fontWeight: "600",
                    marginTop: "15px",
                  }}
                >
                  <i className="fab fa-whatsapp me-2"></i>
                  Book Now
                </button>

              </div>

            </div>

          </div>

        </div>
      </div>
    </div>
  );
})}
          </div>
        </div>
      </section>
    </>
  );
}